import React from "react";
import { VStack } from "@UI/Components/Stack/Stack";
import { Text } from "@UI/Components/Text/Text";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "../messages";

export const EmptyCandidatesPlaceholder: React.FC<JSX.IntrinsicAttributes> = (
  props
) => {
  return (
    <VStack
      spacing="20px"
      justifyContent="center"
      alignItems="center"
      px={{ base: "initial", md: "40px" }}
    >
      <svg
        width="143"
        height="97"
        viewBox="0 0 143 97"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <g opacity="0.6">
          <path
            d="M8.62866 7.10412C8.62866 3.18062 11.8093 0 15.7328 0H127.267C131.191 0 134.372 3.18062 134.372 7.10412V22.0228C134.372 25.9463 131.191 29.1269 127.267 29.1269H15.7328C11.8093 29.1269 8.62866 25.9463 8.62866 22.0228V7.10412Z"
            fill="white"
          />
          <circle cx="23.1919" cy="14.5634" r="8.88015" fill="#EBEBEB" />
          <path
            d="M37.7554 11.0114C37.7554 9.44199 39.0276 8.16974 40.597 8.16974H105.955C107.524 8.16974 108.797 9.44199 108.797 11.0114C108.797 12.5808 107.524 13.853 105.955 13.853H40.597C39.0276 13.853 37.7554 12.5808 37.7554 11.0114Z"
            fill="#EBEBEB"
          />
          <path
            d="M37.7554 18.8259C37.7554 17.6489 38.7096 16.6947 39.8866 16.6947H92.4571C93.6341 16.6947 94.5883 17.6489 94.5883 18.8259C94.5883 20.003 93.6341 20.9571 92.4571 20.9571H39.8866C38.7096 20.9571 37.7554 20.003 37.7554 18.8259Z"
            fill="#EBEBEB"
          />
          <path
            d="M114.48 14.5634C114.48 12.2093 116.388 10.301 118.742 10.301H124.426C126.78 10.301 128.688 12.2093 128.688 14.5634C128.688 16.9175 126.78 18.8259 124.426 18.8259H118.742C116.388 18.8259 114.48 16.9175 114.48 14.5634Z"
            fill="#EBEBEB"
          />
        </g>
        <path
          d="M0.900391 40.0327C0.900391 35.579 4.51083 31.9685 8.96452 31.9685H134.035C138.489 31.9685 142.1 35.579 142.1 40.0327V56.9674C142.1 61.421 138.489 65.0315 134.035 65.0315H8.96452C4.51082 65.0315 0.900391 61.421 0.900391 56.9674V40.0327Z"
          fill="white"
        />
        <circle cx="17.432" cy="48.5" r="10.0802" fill="#EBEBEB" />
        <path
          d="M33.1953 44.4679C33.1953 42.6865 34.6395 41.2423 36.421 41.2423H110.611C112.392 41.2423 113.837 42.6865 113.837 44.4679C113.837 46.2494 112.392 47.6936 110.611 47.6936H36.421C34.6395 47.6936 33.1953 46.2494 33.1953 44.4679Z"
          fill="#EBEBEB"
        />
        <path
          d="M33.1953 53.3385C33.1953 52.0024 34.2784 50.9192 35.6146 50.9192H95.2891C96.6252 50.9192 97.7084 52.0024 97.7084 53.3385C97.7084 54.6746 96.6252 55.7577 95.2891 55.7577H35.6146C34.2784 55.7577 33.1953 54.6746 33.1953 53.3385Z"
          fill="#EBEBEB"
        />
        <path
          d="M119.52 48.5C119.52 45.8278 121.686 43.6615 124.358 43.6615H130.81C133.482 43.6615 135.648 45.8278 135.648 48.5C135.648 51.1722 133.482 53.3385 130.81 53.3385H124.358C121.686 53.3385 119.52 51.1722 119.52 48.5Z"
          fill="#EBEBEB"
        />
        <g opacity="0.6">
          <path
            d="M8.62866 74.9772C8.62866 71.0537 11.8093 67.8731 15.7328 67.8731H127.267C131.191 67.8731 134.372 71.0537 134.372 74.9772V89.8959C134.372 93.8194 131.191 97 127.267 97H15.7328C11.8093 97 8.62866 93.8194 8.62866 89.8959V74.9772Z"
            fill="white"
          />
          <circle cx="23.1919" cy="82.4365" r="8.88015" fill="#EBEBEB" />
          <path
            d="M37.7554 78.8845C37.7554 77.3151 39.0276 76.0428 40.597 76.0428H105.955C107.524 76.0428 108.797 77.3151 108.797 78.8845C108.797 80.4539 107.524 81.7261 105.955 81.7261H40.597C39.0276 81.7261 37.7554 80.4539 37.7554 78.8845Z"
            fill="#EBEBEB"
          />
          <path
            d="M37.7554 86.699C37.7554 85.522 38.7096 84.5678 39.8866 84.5678H92.4571C93.6341 84.5678 94.5883 85.522 94.5883 86.699C94.5883 87.8761 93.6341 88.8302 92.4571 88.8302H39.8866C38.7096 88.8302 37.7554 87.8761 37.7554 86.699Z"
            fill="#EBEBEB"
          />
          <path
            d="M114.48 82.4365C114.48 80.0824 116.388 78.1741 118.742 78.1741H124.426C126.78 78.1741 128.688 80.0824 128.688 82.4365C128.688 84.7906 126.78 86.699 124.426 86.699H118.742C116.388 86.699 114.48 84.7906 114.48 82.4365Z"
            fill="#EBEBEB"
          />
        </g>
      </svg>
      <Text textAlign="center">
        <FormattedMessage
          {...messages["serviceRequest.candidates.emptyPlaceholder"]}
        />
      </Text>
    </VStack>
  );
};
